// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonIcon } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import { navigationDrawerStyles } from "@turnerBlueprint/Overrides/Components/NavigationDrawer";
import { HEADER_HEIGHT_CSS_VAR } from "@turnerBlueprint/XDL/constants";
import IconNavRight from "@turnerBlueprint/XDL/Icons/IconNavRight";
import IconSignout from "@turnerBlueprint/XDL/Icons/IconSignout";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { color, createLinkIconStyles, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

navigationDrawerStyles.menuTriggerButton = {
    size: 16,
    variant: "secondary",
    css: css`
        &,
        &:hover,
        &:focus {
            padding: 0;
            border: none;
            background-color: transparent;
        }

        ${ButtonIcon} {
            color: ${color("common.ui5")};
        }
    `,
};

navigationDrawerStyles.drawer = {
    size: 360,
    cssOverrides: {
        drawerBody: css`
            top: var(${HEADER_HEIGHT_CSS_VAR});
            transform: translate(-100%, 0);
            height: calc(100vh - var(${HEADER_HEIGHT_CSS_VAR}));
            box-shadow: none;
            padding: 10px 16px 16px 16px;
            background-color: ${color("common.ui1")};
            ${xScreen("lte", "xs")} {
                width: 100%;
            }
        `,
        drawerTitle: css`
            display: none;
        `,
        scrim: css`
            background-color: ${color("common.black", 0.5)};
            top: var(${HEADER_HEIGHT_CSS_VAR});
            height: calc(100vh - var(${HEADER_HEIGHT_CSS_VAR}));
        `,
    },
};

navigationDrawerStyles.drawerSectionWrapper = {
    css: css``,
};

navigationDrawerStyles.mainNavigationRow = {
    color: "common.ui1",
    css: css`
        margin: 0;
        padding: 8px 0;

        ${IconWrapper} {
            color: ${color("common.ui5")};
        }
    `,
    moreIconProps: {
        src: IconNavRight,
        size: 14,
        css: css`
            height: 20px;
            &, svg {
                width: auto;
            }
            justify-content: flex-end;
        `,
    },
};

navigationDrawerStyles.mainNavigationRowTypography = {
    color: "text.main",
    weight: fontConfig.weight.regular,
    size: 14,
    lineHeight: "22px",
};

navigationDrawerStyles.drawerSectionSeparator = {
    css: css`
        margin: 16px auto;
        background-color: ${color("common.border")};
        height: 1px;
        width: 100%;
    `,
};

navigationDrawerStyles.accountPanelSectionWrapper = {
    css: css`
        display: flex;
        align-items: center;
        width: 100%;
    `,
};

navigationDrawerStyles.signOutButton = {
    ...createLinkIconStyles(IconSignout, {
        icon: {
            position: "right",
        },
    }),
};

navigationDrawerStyles.panelMenu = {
    bodyColor: "common.ui1",
    backButton: {
        css: css`
            &,
            &:not(:disabled):hover,
            &:focus {
                padding: 0;
                border: none;
                background-color: transparent;
                font-size: 14px;
                line-height: 22px;
                font-weight: ${fontConfig.weight.bold};
                min-height: 22px;
                color: ${color("common.ui6")};
            }

            ${IconWrapper} {
                color: ${color("common.ui5")};
                margin-right: 8px;
            }
        `,
    },
    panelChildrenSeparator: {
        css: css`
            margin: 16px auto;
            background-color: ${color("common.border")};
            height: 1px;
            width: calc(100% - 32px);
        `,
    },
    cssOverrides: {
        menu: css`
            padding: 0 16px 16px 16px;
        `,
        children: css`
            background-color: ${color("common.ui1")};
        `,
    },
};
